import {Route, Routes} from "react-router-dom";
import List from "./List";
import {RouterProps} from "../../../RouterProps";
import Detail from "./Detail";

export default function LikeRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/:contentCommentLikeId'} element={<Detail {...props} />} />
        </Routes>
    </>
}